
import { Component, Prop, Vue, TSX } from 'vue-facing-decorator'
import { buildAnswerMap, formatAnswer, getSignStatusText, getSignStatusClass } from '@/common/sign'

/**
 * Props 必须显式声明并用 TSX<Props>()(Vue) 建类：
 * 父级是用 <RecordDetail modelValue={row} rows={...} /> 这种 TSX 传参的，
 * 没有这份声明 TSX 就认不出 modelValue/rows（同 wechat 的 store-form/edit-item）
 */
interface Props {
  modelValue?: any
  rows?: any[]
}

@Component({
  emits: ['reject']
})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop()
  modelValue: any;

  /** 活动的表头列表：itemList 里存的是表头 id，要拿它翻成「名称 + 值」 */
  @Prop()
  rows: any[];

  formatAnswer = formatAnswer;
  getSignStatusText = getSignStatusText;
  getSignStatusClass = getSignStatusClass;

  get answerMap() {
    return buildAnswerMap(this.modelValue?.itemList);
  }

  get mobileText() {
    let user = this.modelValue?.userInfo;
    return user?.mobile || user?.phone || "未注册用户";
  }

  get payText() {
    if (this.modelValue?.isPay != 1) {
      return this.modelValue?.orderNumber ? "未支付" : "免费活动";
    }
    return `¥${this.modelValue.payAmount}`;
  }
}
